const STORAGE_KEY = "movigo_admin_token";

export function getStoredToken() {
  return window.localStorage.getItem(STORAGE_KEY);
}

export function storeToken(token) {
  window.localStorage.setItem(STORAGE_KEY, token);
}

export function clearStoredToken() {
  window.localStorage.removeItem(STORAGE_KEY);
}
